module.exports = "/images/brajan@2x.jpg?fca5f1dc05399b385cdf453950acc542";